export default "__VITE_ASSET__1080ae51__"